<template>
  <section>
    <h2
      class="font-russo text-[28px] font-bold text-[#FF0000] py-8"
      v-if="title"
    >
      {{ title }}
    </h2>
    <div class="flex gap-2" v-if="images">
      <div
        class="gap-8 px-8 grid grid-rows-3 md:grid-rows-1 md:grid-cols-3 items-center m-auto"
      >
        <div v-for="(image, index) in images" :key="index" class="col-span-1">
          <img
            decoding="async"
            :src="image"
            :alt="title || 'Rally Navigator customer review'"
            class="max-h-[133px] m-auto object-cover"
          />
        </div>
      </div>
    </div>
    <p
      class="border-l-2 border-gray-400 pl-2 text-gray-400 text-sm italic mt-8"
      v-if="description"
    >
      {{ description }}
    </p>
    <h2 v-if="reviewer" class="py-8 text-[#FF0000] text-xl">{{ reviewer }}</h2>
  </section>
</template>

<script>
export default {
  name: 'ReviewRow',
  props: {
    images: Array,
    title: String,
    description: String,
    reviewer: String,
  },
};
</script>

<style scoped></style>
